import { useTheme } from "@web-src/themes/useTheme";

interface UnreadCountBoxProps {
  count: number;
  className?: string;
  isDotOnly?: boolean;
}

const MAX_COUNT = 99;

export const UnreadCountBox = ({
  count,
  className,
  isDotOnly,
}: UnreadCountBoxProps) => {
  const { tcx, customTheme } = useTheme();
  if (isDotOnly) {
    return (
      <div
        className={tcx(
          "flex h-[22px] w-[20px] items-center justify-center",
          className
        )}
      >
        <div
          className={tcx("h-[10px] w-[10px] rounded-full", {
            blue: "bg-primary-50",
            dark: "bg-grey-500",
            light: "bg-primary-300",
          })}
        />
      </div>
    );
  }
  return (
    <div
      className={tcx(
        "flex h-[22px] w-[22px] min-w-[22px] items-center justify-center px-1 transition-colors duration-300",
        {
          light: "bg-primary-300",
          dark: "bg-grey-700",
          blue: "bg-[rgba(255_255_255_/_0.32)]",
        },
        count > 10 ? "w-[32px] rounded-2xl" : "rounded-full",
        className
      )}
    >
      <span
        className="font-secondary text-xs font-semibold text-white"
        style={{
          textShadow: {
            light: "0px 0px 4px rgba(17, 104, 193, 0.60)",
            dark: "0px 0px 4px rgba(58, 61, 64, 0.60)",
            blue: "0px 0px 4px rgba(17, 104, 193, 0.85)",
          }[customTheme],
        }}
      >
        {count > MAX_COUNT ? `${MAX_COUNT}+` : count}
      </span>
    </div>
  );
};
